import { render, staticRenderFns } from "./OrderAddDialog.vue?vue&type=template&id=6ec0120c&scoped=true"
import script from "./OrderAddDialog.vue?vue&type=script&lang=js"
export * from "./OrderAddDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderAddDialog.vue?vue&type=style&index=0&id=6ec0120c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec0120c",
  null
  
)

export default component.exports